import * as types from "./notificationsTypes";
import * as action from "./notificationsActions";
import * as api from "./notificationsAPIs";
import {
  call,
  put,
  all,
  takeLatest,
  takeEvery,
  select
} from "redux-saga/effects";
import { client } from "~/utils/medproSDK";
import AppId from "~/utils/partner";
import { huyi } from "~/utils/clog";
import { get } from "lodash";

function* getNotification({ payload }) {
  const data = yield call(api.getNotification, payload);
  if (!data.error_code) {
    yield put(action.getNotificationSuccess(data));
  } else {
    yield put(action.getNotificationFail(data.error_code));
  }
}

function* getMoreNotification({ payload }) {
  const data = yield call(api.getMoreNotification, payload);
  if (!data.error_code) {
    yield put(action.getMoreNotificationSuccess(data));
  } else {
    yield put(action.getMoreNotificationFail(data.error_code));
  }
}

function* updateReadNotification({ payload }) {
  const data = yield call(api.updateReadNotification, payload);
  // console.log("data", data);
  if (!data.error_code) {
    yield put(action.getNotification(payload));
  } else {
    console.log("update error");
  }
}

function* deleteAllNotification({ payload }) {
  const data = yield call(api.deleteAllNotification, payload);
  // console.log(data);
  if (!data.error_code) {
    yield put(action.clearNotificationAtStore());
    yield put(action.getNotification(payload));
  } else {
    console.log("delete error");
  }
}

function* deleteNotification({ payload }) {
  const data = yield call(api.deleteNotification, payload);
  // console.log(data);
  if (!data.error_code) {
    yield put(action.clearNotificationAtStore());
    yield put(action.getNotification(payload));
    yield put(action.getNotificationOnPage(payload));
  } else {
    console.log("delete error");
  }
}

function* markAllNotiAsRead() {
  const noti = yield select(state => state.notification);
  const user = yield select(state => state.user.info);
  if (noti.data.length >= noti.total_new) {
    const listUnreadNotiId = noti.data
      .slice(0, noti.total_new)
      .map(noti => noti.id)
      .join(",");
    const data = yield call(api.updateReadNotification, {
      noti_id: listUnreadNotiId,
      user_id: user.user_id,
      access_token: user.access_token
    });
    if (!data.error_code) {
      const deviceType = yield select(state => state.global.device.type);
      if (deviceType === "mobile") {
        yield put(
          action.getNotification({
            user_id: user.user_id,
            access_token: user.access_token
          })
        );
      } else {
        yield put(
          action.getNotificationOnPage({
            user_id: user.user_id,
            access_token: user.access_token,
            page: 0
          })
        );
      }
    } else {
      console.log("update error");
    }
  } else {
    const allUnreadNoti = yield call(api.getAllNotification, {
      total: noti.total_new,
      user_id: user.user_id,
      access_token: user.access_token
    });
    const listUnreadNotiId = allUnreadNoti.data.map(noti => noti.id).join(",");
    const data = yield call(api.updateReadNotification, {
      noti_id: listUnreadNotiId,
      user_id: user.user_id,
      access_token: user.access_token
    });
    if (!data.error_code) {
      const deviceType = yield select(state => state.global.device.type);
      if (deviceType === "mobile") {
        yield put(
          action.getNotification({
            user_id: user.user_id,
            access_token: user.access_token
          })
        );
      } else {
        yield put(
          action.getNotificationOnPage({
            user_id: user.user_id,
            access_token: user.access_token,
            page: 0
          })
        );
      }
    } else {
      console.log("update error");
    }
  }
}

// const matchNotiType = (type = "") => {
//   switch (type) {
//     case "bookingNoti":
//       return "1,2";
//     case "systemNoti":
//       return "4,5";
//     case "promoteNoti":
//       return "3";
//     default:
//       return "1,2,3,4,5";
//   }
// };

function* getNotificationOnPage({ categories }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const user = yield select(state => state.user);
    // if (user.info) {
    //   const partnerid = yield select(state => state.totalData.partnerId);
    //   const response = yield client.getAllNotifByUser(
    //     // { category: 1 },
    //     { partnerid, appid: AppId, token: user.info?.token || "", platform }
    //   );
    //   yield put(action.getNotificationSuccess(response.data));
    // }
  } catch (error) {
    huyi({ name: "error-getNotificationOnPage", child: error, type: 0 });
  }
}

function* checkReadNoti({ id }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    yield client.markViewedNotif({ id }, { platform });
    yield put(action.getNotificationOnPage({ category: 1 }));
  } catch (error) {
    console.log(error);
  }
}

export default function* root() {
  yield all([
    takeLatest(types.GET_NOTIFICATION_ON_PAGE, getNotificationOnPage),
    takeLatest(types.CHECK_READ_NOTI, checkReadNoti),
    takeLatest(types.GET_NOTIFICATION, getNotification),
    takeLatest(types.GET_MORE_NOTIFICATION, getMoreNotification),
    takeEvery(types.UPDATE_READ_NOTIFICATION, updateReadNotification),
    takeLatest(types.DELETE_ALL_NOTIFICATION, deleteAllNotification),
    takeLatest(types.DELETE_NOTIFICATION, deleteNotification),
    takeLatest(types.MARK_ALL_NOTI_AS_READ, markAllNotiAsRead)
  ]);
}
